import has from 'transmute/has';
export function isThreadListMember(member) {
  return has('threadId', member);
}